<script>
import { mapActions, mapGetters } from 'vuex'
import { swal } from '../helpers/handle_error.js'

//  Nav-bar Component
export default {
  data() {
    return {
    };
  },

  components: { },

  mounted() { },
  computed:{
    ...mapGetters('auth', ['getUser'])
  },
  methods: {
    ...mapActions('auth', ['logOut', 'logOutClientSide']),
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logout(){
      swal.loading()
      this.logOut(true)
      .then(()=>{
        swal.close()
        window.location.replace('/login')
      })
      .catch(()=>{
        this.logOutClientSide()
        swal.close()
        window.location.replace('/login')
      })
    }
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo3.png" alt height="26" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo3.png" alt height="55" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo3.png" alt height="26" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo3.png" alt height="55" />
            </span>
          </router-link>
        </div>
        <!-- menu-btn -->
        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <img class="rounded-circle header-profile-user ms-1" src="@/assets/images/users/avatar.jpg" alt="Avatar" />
            <span class="d-none d-xl-inline-block ms-1">{{ getUser.name }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item to="/account">
            <i class="bx bxs-lock font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.henry.list.profile") }}
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <a href="JavaScript:void(0);" @click="logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>
